import PropTypes from "prop-types";
import classnames from "classnames";

const Spinner = ({ label = "This page is loading" }) => (
  <div
    aria-busy="true"
    aria-label={label}
    aria-live="polite"
    role="alertdialog"
    tabIndex={0}
    className="flex w-full items-center justify-center py-8"
  >
    <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-primary" />
  </div>
);

export const LoaderOverlay = ({ active, children }) => {
  return active ? <Spinner /> : children;
};

LoaderOverlay.propTypes = {
  active  : PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired
};

export const ComponentSpinner = () => {
  return <Spinner />;
};

ComponentSpinner.propTypes = {
  height: PropTypes.string
};

export function BarSpinner ({ className = "" }) {
  return (
    <div
      className={classnames(
        "flex items-center justify-center gap-0.5",
        className
      )}
    >
      {Array.from({ length: 12 }).map((_, index) => (
        <span
          key={index}
          className="h-4 w-0.5 animate-pulse bg-primary"
          style={{ animationDelay: `${index * 0.08}s` }}
        />
      ))}
    </div>
  );
}

BarSpinner.propTypes = {
  className: PropTypes.string
};
